exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box[data-v-9b6e7b5e]{position:center;width:60%;min-width:1000px;margin:50px auto;box-shadow:0 2px 8px 0 rgba(0,0,0,.1);min-height:500px}.content-body[data-v-9b6e7b5e]{padding:0 40px}.search-box .el-input__inner[data-v-9b6e7b5e]{width:221px;height:34px;line-height:34px}.el-input[data-v-9b6e7b5e],.el-textarea[data-v-9b6e7b5e]{width:300px}.doc-api-page[data-v-9b6e7b5e]{width:1170px;padding:0 0 30px;margin:0 auto}.edit-submit-btn[data-v-9b6e7b5e]{background:#f16622;color:#fff;margin-left:92px;margin-top:20px;border:none}.part-title[data-v-9b6e7b5e]{width:100%;line-height:35px;color:#424456;font-size:15px;padding-bottom:15px;font-weight:700}.el-upload-list .el-upload-list--text[data-v-9b6e7b5e]{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b6e7b5e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/help/ticket.vue
// module id = 965
// module chunks = 0